<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="17.5" height="21.5" viewBox="0 0 17.5 21.5">
    <path :style="{stroke:color}" class="a" d="M12,22s8-4,8-10V5L12,2,4,5v7C4,18,12,22,12,22Z" transform="translate(-3.25 -1.25)"/>
  </svg>
</template>

<script>
export default {
  name: "AdminIcon",
  props: {
    color: String
  }
}
</script>

<style scoped>
.a {
  fill: none;
  stroke: #8ea2a8;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.5px;
}
</style>
